import React, { useState } from "react";
import BaseModal from "../BaseModal";
import Button from "../../Buttons/Button";
import "./style.css";

/**
 * Modal for Deleting a Patient Visit Record
 * @param {function} onClose - Function to handle the modal close event
 */

export const DeleteVisitRecord = ({ onClose }) => {
  const [isRecordDeleted, setIsRecordDeleted] = useState(false);

  const handleCancel = () => {
    //Logic for cancel deletion goes here
    onClose();
  };

  // Event handler for when the user clicks the "delete" button
  const handleDelete = async (event) => {
    try {
      // Replace with your actual API call
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // After successful delete, set the state to show FlyerMessage
      setIsRecordDeleted(true);
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  // Event handler for when the user clicks the "Close" button on FlyerMessage
  const handleFlyerMessageClose = () => {
    onClose();
    // Reset the state to hide FlyerMessage
    setIsRecordDeleted(false);
  };

  return (
    //Reusable BaseModal - pass props : title and onClose
    <BaseModal
      title="Delete Patient Visit Record"
      onClose={onClose}
      showFlyerMessage={isRecordDeleted}
      flyerMessageText={"Record has been deleted successfully"}
      onFlyerMessageClose={handleFlyerMessageClose}
    >
      <p className="delete-modal-text">
        Are you surely want to delete the particular visit record of the
        patient?
      </p>

      <div className="delete-btn-group ">
        {/* Reusable component Button - props btnType & onClick*/}
        <Button btnType="cancel" onClick={handleCancel} />
        <Button btnType="delete" onClick={handleDelete} />
      </div>
    </BaseModal>
  );
};

export default DeleteVisitRecord;
